import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { ConnectionRunsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createConnectionRun = (data): any => action(types.CREATE_CONNECTION_RUN_REQUESTED, data);

export const updateConnectionRun = (data): any => action(types.UPDATE_CONNECTION_RUN_REQUESTED, data);

export const deleteConnectionRun = (connectionRunId): any => action(types.UPDATE_CONNECTION_RUN_REQUESTED, connectionRunId);

export const getConnectionRun = (connectionRunId): any => action(types.GET_CONNECTION_RUN_REQUESTED, connectionRunId);

export const getAllConnectionRuns = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_CONNECTION_RUNS_REQUESTED, {
  pagination,
  compile,
});

export const selectConnectionRun = (connectionRunId): any => action(types.SELECT_CONNECTION_RUN_REQUESTED, {
  currentConnectionRunId: connectionRunId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createConnectionRunPending: (payload): any => action(types.CREATE_CONNECTION_RUN_PENDING, payload),
  createConnectionRunSuccess: (response): any => {
    const currentConnectionRun = response.entities.connectionRuns[response.result];
    // history.push(`/payment/${currentConnectionRun.paymentCollection.id}/review`);
    return action(types.CREATE_CONNECTION_RUN_SUCCESS, {
      connectionRunsById: response.entities.connectionRuns,
      currentConnectionRunId: response.result,
    });
  },
  updateConnectionRunPending: (payload): any => action(types.UPDATE_CONNECTION_RUN_PENDING, payload),
  updateConnectionRunSuccess: (response): any => action(types.UPDATE_CONNECTION_RUN_SUCCESS, {
    connectionRunsById: response.entities.connectionRuns,
    currentConnectionRunId: response.result,
  }),
  updateConnectionRunFailed: (error): any => action(types.UPDATE_CONNECTION_RUN_FAIL, {
    backendErrors: error,
  }),
  deleteConnectionRunPending: (): any => action(types.UPDATE_CONNECTION_RUN_PENDING, {}),
  deleteConnectionRunSuccess: (response, userId): any => {
    localStorage.set(userId, { currentConnectionRunId: null });
    history.push('/connectionRuns');

    return action(types.DELETE_CONNECTION_RUN_SUCCESS, {
      currentConnectionRunId: response,
    });
  },
  getConnectionRunPending: (): any => action(types.GET_CONNECTION_RUN_PENDING, {}),
  getConnectionRunSuccess: (response): any => action(types.GET_CONNECTION_RUN_SUCCESS, {
    connectionRunsById: response.entities.connectionRuns,
    currentConnectionRunId: response.result,
  }),
  getConnectionRunFailed: (error): any => action(types.GET_CONNECTION_RUN_FAIL, {
    backendErrors: error,
  }),
  deleteConnectionRunFailed: (error): any => action(types.UPDATE_CONNECTION_RUN_FAIL, {
    backendErrors: error,
  }),
  getAllConnectionRunsPending: (pagination): any => action(types.GET_ALL_CONNECTION_RUNS_PENDING, { pagination }),
  getAllConnectionRunsSuccess: (response, meta): any => action(types.GET_ALL_CONNECTION_RUNS_SUCCESS, {
    connectionRunsById: response.entities.connectionRuns,
    connectionRunIds: response.result,
    meta,
  }),
  getAllConnectionRunsFailed: (error): any => action(types.GET_ALL_CONNECTION_RUNS_FAIL, {
    backendErrors: error,
  }),
  createConnectionRunFailed: (error): any => action(types.CREATE_CONNECTION_RUN_FAIL, {
    backendErrors: error,
  }),
};

export default null;
